"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerDataToJSON = exports.CustomerDataFromJSONTyped = exports.CustomerDataFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CustomerDataFromJSON(json) {
    return CustomerDataFromJSONTyped(json, false);
}
exports.CustomerDataFromJSON = CustomerDataFromJSON;
function CustomerDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': !(0, runtime_1.exists)(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !(0, runtime_1.exists)(json, 'lastName') ? undefined : json['lastName'],
        'phoneNumbers': !(0, runtime_1.exists)(json, 'phoneNumbers') ? undefined : (json['phoneNumbers'].map(_1.PhoneNumberWithTypeFromJSON)),
        'birthName': !(0, runtime_1.exists)(json, 'birthName') ? undefined : json['birthName'],
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'gender': !(0, runtime_1.exists)(json, 'gender') ? undefined : (0, _1.GenderFromJSON)(json['gender']),
        'billingAddress': !(0, runtime_1.exists)(json, 'billingAddress') ? undefined : (0, _1.AddressFromJSON)(json['billingAddress']),
        'businessPartnerNo': !(0, runtime_1.exists)(json, 'businessPartnerNo') ? undefined : json['businessPartnerNo'],
        'bankTransferReference': json['bankTransferReference'],
        'birthDay': !(0, runtime_1.exists)(json, 'birthDay') ? undefined : json['birthDay'],
        'hasMobileNumber': !(0, runtime_1.exists)(json, 'hasMobileNumber') ? undefined : json['hasMobileNumber'],
        'payment': (0, _1.StoredPaymentDataFromJSON)(json['payment']),
        'fullChangeAllowed': !(0, runtime_1.exists)(json, 'fullChangeAllowed') ? undefined : json['fullChangeAllowed'],
        'permissions': (0, _1.PermissionsFromJSON)(json['permissions']),
        'extra': !(0, runtime_1.exists)(json, 'extra') ? undefined : (0, _1.ReadonlyCustomerDataExtraFromJSON)(json['extra']),
        'customerSpecificHint': !(0, runtime_1.exists)(json, 'customerSpecificHint') ? undefined : json['customerSpecificHint'],
        'personalCoupon': !(0, runtime_1.exists)(json, 'personalCoupon') ? undefined : (0, _1.ReadonlyCustomerDataPersonalCouponFromJSON)(json['personalCoupon']),
        'verificationStatus': !(0, runtime_1.exists)(json, 'verificationStatus') ? undefined : (0, _1.VerificationStatusFromJSON)(json['verificationStatus']),
    };
}
exports.CustomerDataFromJSONTyped = CustomerDataFromJSONTyped;
function CustomerDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phoneNumbers': value.phoneNumbers === undefined ? undefined : (value.phoneNumbers.map(_1.PhoneNumberWithTypeToJSON)),
        'birthName': value.birthName,
        'email': value.email,
        'gender': (0, _1.GenderToJSON)(value.gender),
        'billingAddress': (0, _1.AddressToJSON)(value.billingAddress),
        'businessPartnerNo': value.businessPartnerNo,
        'bankTransferReference': value.bankTransferReference,
        'birthDay': value.birthDay,
        'hasMobileNumber': value.hasMobileNumber,
        'payment': (0, _1.StoredPaymentDataToJSON)(value.payment),
        'fullChangeAllowed': value.fullChangeAllowed,
        'permissions': (0, _1.PermissionsToJSON)(value.permissions),
        'extra': (0, _1.ReadonlyCustomerDataExtraToJSON)(value.extra),
        'customerSpecificHint': value.customerSpecificHint,
        'personalCoupon': (0, _1.ReadonlyCustomerDataPersonalCouponToJSON)(value.personalCoupon),
        'verificationStatus': (0, _1.VerificationStatusToJSON)(value.verificationStatus),
    };
}
exports.CustomerDataToJSON = CustomerDataToJSON;
//# sourceMappingURL=CustomerData.js.map